module.exports = __webpack_public_path__ + "static/media/scrollSlideLeft.c721dce5.svg";